// extracted by mini-css-extract-plugin
module.exports = {"featureWrapper":"styles__featureWrapper--1Y-FX","title":"styles__title--222D2"};